import imgMindigits from "../images/mindigits.png";
export const MinDigitsBrand = ({ id }) => {
    return <a
        href={`https://reestr.digital.gov.ru/reestr/${id}/`}
        target="_blanck"
        style={{
            textDecoration: "none",
            // fontSize: "18px",
            letterSpacing: "1px",
            color: "#00000090",
        }}
    >
        <div style={{ lineHeight: "calc(var(--brands-font-size) * 1.2)" }}>Внесено в реестр</div>
        <div className="d-flex" style={{ lineHeight: "calc(var(--brands-font-size) * 1.2)" }}>
            <div>
                <img src={imgMindigits}

                />
            </div>
            <div style={{ marginRight: ".5rem" }}>
                <div>Минцифры</div>
                <div>России</div>
            </div>
        </div>
    </a>
}